import ApplicationController from './application_controller'

/* This is the custom StimulusReflex controller for ProjectsReflex.
 * Learn more at: https://docs.stimulusreflex.com
 */
export default class extends ApplicationController {
  static targets = [ "addPaymentForm"];
  /* Reflex specific lifecycle methods.
   * Use methods similar to this example to handle lifecycle concerns for a specific Reflex method.
   * Using the lifecycle is optional, so feel free to delete these stubs if you don't need them.
   *
   * Example:
   *
   *   <a href="#" data-reflex="ProjectsReflex#example">Example</a>
   *
   * Arguments:
   *
   *   element - the element that triggered the reflex
   *             may be different than the Stimulus controller's this.element
   *
   *   reflex - the name of the reflex e.g. "ProjectsReflex#example"
   *
   *   error - error message from the server
   */
  connect() {
	super.connect();
    if (document.getElementById("invoice_issue_date")) {
	    flatpickr('#invoice_issue_date',{defaultDate: [document.getElementById("invoice_issue_date").value], altInput: true});
	    flatpickr('#invoice_due_date',{defaultDate: [document.getElementById("invoice_due_date").value],altInput: true});
	  }
  }


  afterReflex() {
	  super.afterReflex();
	  flatpickr('#invoice_issue_date',{defaultDate: [document.getElementById("invoice_issue_date").value],altInput: true});
	  flatpickr('#invoice_due_date',{defaultDate: [document.getElementById("invoice_due_date").value],altInput: true});
  }
  
  addPayment(event) {
	 event.preventDefault();
	 this.addPaymentFormTarget.style.display = "block";
	 document.getElementById("invoice_payment_payment_method").focus();
  }
  cancelAddPayment(event) {
	 event.preventDefault();
	 this.addPaymentFormTarget.style.display = "none";	  
	 document.querySelector("#invoice_payment_errors").innerHTML = "";
	 document.querySelector("#invoice_payment_errors").style.display = "none";
  }
  
  beforeRefresh(element, reflex) {
    element.innerText = 'Updating...';
  }
   
   refreshSuccess(element, reflex) {
     element.innerText = 'Updated Successfully.';
   }

   refreshError(element, reflex, error) {
      element.innerText = 'Update Failed!'
   }
   
   afterSelecttask(element, reflex) {
	   var task_id = element.getAttribute('data-taskid');
	   var project_id = element.getAttribute('data-projectid');
       history.pushState(null, null, '/projects/' + project_id + "/" + task_id);
       window.scrollTo(0,0);
   }


}